import React from 'react';
import cn from 'classnames';

import {IButtonChildrenProps} from './IButtonChildren';

import styles from '../Button.module.scss';

const ButtonChildren = ({children, contentClassNames, loading}: IButtonChildrenProps) => {
	return (
		<>
			{loading && (
				<span className={cn(styles['btn__loader'], 'btn__loader')}>
					<span />
				</span>
			)}
			{children &&
				<span className={cn(styles['btn__content'], 'btn__content', contentClassNames)}>
					{children}
				</span>
			}
		</>
	);
};

export default ButtonChildren;
